import { render, staticRenderFns } from "./flightpath-maploader.vue?vue&type=template&id=4cf887fe&scoped=true"
import script from "./flightpath-maploader.vue?vue&type=script&lang=ts"
export * from "./flightpath-maploader.vue?vue&type=script&lang=ts"
import style0 from "./flightpath-maploader.vue?vue&type=style&index=0&id=4cf887fe&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf887fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/apps/front/flightpath-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf887fe')) {
      api.createRecord('4cf887fe', component.options)
    } else {
      api.reload('4cf887fe', component.options)
    }
    module.hot.accept("./flightpath-maploader.vue?vue&type=template&id=4cf887fe&scoped=true", function () {
      api.rerender('4cf887fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flightpath-components/lib-components/flightpath-maploader.vue"
export default component.exports